<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import DRBtn from "@/components/UI/DRBtn.vue";

defineProps<{
  selectedCount: number;
  isDeleting?: boolean;
  isCreatingFinding?: boolean;
  showCreateFinding?: boolean;
}>();

const emit = defineEmits<{
  (e: "move"): void;
  (e: "exclude"): void;
  (e: "delete"): void;
  (e: "create-finding"): void;
  (e: "clear"): void;
}>();

const { t } = useTranslation();
</script>

<template>
  <div
    class="selection-bar px-4 py-2 bg-primary bg-opacity-10 border-bottom d-flex align-items-center gap-3"
  >
    <span class="fw-medium">
      {{ selectedCount }} {{ t("report:photos.selected") }}
    </span>

    <div class="d-flex align-items-center gap-2">
      <!-- Create finding button -->
      <DRBtn
        v-if="showCreateFinding"
        icon="bi-plus-circle"
        :label="t('report:photos.actions.createFinding')"
        variant="outline"
        size="xs"
        :loading="isCreatingFinding"
        @click="emit('create-finding')"
      />

      <!-- Move to section button -->
      <DRBtn
        icon="bi-folder-symlink"
        :label="t('report:photos.actions.moveToSection')"
        variant="outline"
        size="xs"
        @click="emit('move')"
      />

      <!-- Exclude button -->
      <DRBtn
        icon="bi-eye-slash"
        :label="t('report:photos.actions.exclude')"
        variant="outline"
        size="xs"
        @click="emit('exclude')"
      />

      <!-- Delete button -->
      <DRBtn
        icon="bi-trash"
        :label="t('report:photos.actions.delete')"
        variant="outline-danger"
        size="xs"
        :loading="isDeleting"
        @click="emit('delete')"
      />
    </div>

    <DRBtn
      :label="t('report:photos.clearSelection')"
      variant="flat"
      size="xs"
      class="ms-auto py-2"
      @click="emit('clear')"
    />
  </div>
</template>

<style lang="scss" scoped>
.selection-bar {
  flex-shrink: 0;
}
</style>
